import React, { useEffect, useState } from "react";
import { ConnectedProps, connect, useSelector } from "react-redux";
import { Pickers } from "pages/pickers/Pickers";
import { PENDING_PICKER_STATUS, ACTIVE_PICKER_STATUS } from "utils/constants";
import {
  PickersParamsType,
  ParamsMiddlewareType,
  PickerContainerTypes,
} from "./types";
import { AppDispatch, RootState } from "store";
import { actions, pickersSelector } from "reducers/pickers";
import { actions as detailPickersActions } from "reducers/detailPicker";
import { NotificationStateType } from "reducers/types/notification";
import { actions as notificationActions } from "reducers/notification";
import { hasPickerWrongFilesSelector } from "reducers/detailPicker";
import { pickerTabs } from "./types";
import { sessionSelector } from "reducers/session";
import { useHistory, useLocation } from "react-router-dom";

const PendingUserAdminContainer = (
  props: PickerContainerTypes & ConnectorProps
): JSX.Element => {
  const { countryCode } = useSelector(sessionSelector);
  const history = useHistory();
  const location = useLocation();
  const [shouldRenderTabContent, setShouldRenderTabContent] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") as pickerTabs;
    if (tab === "pending" || tab === "pickers") {
      props.setActualPage(tab);
    }
    setShouldRenderTabContent(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, props.setActualPage]);

  const changePage = (page: pickerTabs) => {
    if (props.isDetail || props.actualPage !== page) {
      props.setActualPage(page);
      history.replace(`/${countryCode}/pickers?tab=${page}`);
    }
  };

  useEffect(() => {
    props.setCollapseTable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!shouldRenderTabContent) return;
    const filters =
      props.actualPage === "pending"
        ? {
            ...props.filters,
            status: PENDING_PICKER_STATUS.join(","),
          }
        : {
            ...props.filters,
            status: "",
          };
    const searchParams = {
      ...filters,
      status:
        props.actualPage === "pickers"
          ? ACTIVE_PICKER_STATUS.join(",")
          : filters.status,
      identificationType: props.filters.identificationType?.tag,
    };

    const filtersExtra = { limit: 10 };
    props.setPendingUserExtraFilters(filtersExtra);
    props.setPendingUserFilters(filters);
    props.getPendingUser({ ...filtersExtra, ...searchParams });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.actualPage, shouldRenderTabContent]);

  useEffect(() => {
    props.resetDetailPicker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shouldRenderTabContent ? (
    <Pickers {...props} changePage={changePage} testId="pickers" />
  ) : (
    <></>
  );
};

const mapStateToProps = (state: RootState) => ({
  pendingUsers: pickersSelector(state).users,
  filters: pickersSelector(state).filters,
  filtersExtra: pickersSelector(state).filtersExtra,
  filtersExtraSeeMore: pickersSelector(state).filtersExtraSeeMore,
  seeMore: pickersSelector(state).seeMore,
  actualPage: pickersSelector(state).actualPage,
  wrongFiles: hasPickerWrongFilesSelector(state),
  collapseTable: pickersSelector(state).collapseTable,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  reset: () => {
    dispatch(actions.reset());
  },
  resetDetailPicker: () => {
    dispatch(detailPickersActions.resetPicker());
  },
  getPendingUser: (params: ParamsMiddlewareType) => {
    dispatch(actions.getPendingUserRequest(params));
  },
  setPendingUserFilters: (filters: PickersParamsType) => {
    dispatch(actions.setPendingUserFilters(filters));
  },
  setPendingUserExtraFilters: (extraFilters: PickersParamsType) => {
    dispatch(actions.setPendingUserExtraFilters(extraFilters));
  },
  setActualPage: (page: pickerTabs) => {
    dispatch(actions.setActualPage(page));
  },
  getPendingUsersExportRequest: (
    params: ParamsMiddlewareType,
    element: HTMLElement
  ) => {
    element.blur();
    dispatch(actions.getPendingUserExportRequest(params));
  },
  getMorePendingUser: (params: ParamsMiddlewareType) => {
    dispatch(actions.getMorePendingUserRequest(params));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(actions.setCollapseTable(collapse));
  },
});
const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(PendingUserAdminContainer);
